<template>
  <div class="page update-page">
    <Header title="激活账号"></Header>
    <ActivationStep :activeNum="3"></ActivationStep>

    <div class="content">
      <van-form @submit="onSubmit" :show-error="false" v-if="isPassword" ref="submitForm">
        <van-field v-model="params.newPassword" label="新密码" type="password"
          placeholder="请输入新密码"
          :rules="rules.passwordRule" />
        <van-field v-model="params.newPasswordAgain" label="确认新密码"
          placeholder="请再次输入新密码" type="password"
          :rules="rules.passwordAgainRule" />
        <van-field v-model="params.verifyCode" label="验证码"
          placeholder="验证码"
          :rules="[{ required: true,  message: '请输入验证码' }]" >
          <template #button>
            <div :style="disableSendBtn?'color:grey':'color:#00545e'" @click="getVerifyCode">获取验证码{{countDownText}}</div>
          </template>
        </van-field>
        <div class="activation_btn_box">
          <div class="btn agree_btn" @click="handleActivation()">激活</div>
          <div class="btn disagree_btn" @click="goBack()">返回</div>
        </div>
      </van-form>
    </div>

    <van-overlay :show="hintOverlay" @click="hintOverlay = false">
      <div class="wrapper-overlay" @click.stop>
        <div class="content-overlay">
          <div class="content-title">激活账号成功,请重新登录账号！</div>
          <div class="overlay-block"></div>
          <div class="overlay-btn" @click="handleLogout()">确定</div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import validators from '@/utils/validators'
import Header from '@/components/header'
import centerApi from '../../api/center'
import { cryptoUtils } from '@/utils/common'
import { userUtils } from '@/utils/auth'
import ActivationStep from '@/components/activation-step'
export default {
  components: {
    Header,
    ActivationStep
  },
  data () {
    var checkPassword = validators.checkPassword
    var checkMobile = validators.checkMobile
    var checkPasswordAgain = (val) => {
      if (val !== this.params.newPassword) {
        return false
      }
    }
    return {
      params: {
        oldPassword: '',
        newPassword: '',
        newPasswordAgain: '',
        verifyCode: '',
        mobileNo: ''
      },
      disableSendBtn: false,
      countDownIndex: 0,
      userInfo: {},
      isPassword: true,
      hintOverlay: false,
      rules: {
        passwordRule: [{ required: true, validator: checkPassword, message: '密码必须由8-12位数字,大小写字母和特殊字符其中三种组成' }],
        passwordAgainRule: [{ required: true, validator: checkPasswordAgain, message: '两次密码输入不一致' }],
        mobileRule: [{ required: true, validator: checkMobile, message: '请输入正确手机号' }]
      },
      isLoggedIn: false
    }
  },
  computed: {
    countDownText () {
      return this.countDownIndex > 0 ? '(' + this.countDownIndex + ')' : ''
    }
  },
  created () {
    this.userInfo = userUtils.getClientInfo() || {}
    if (this.userInfo.clientUserDTO && this.userInfo.clientUserDTO.userMobile) {
      this.params.mobileNo = this.userInfo.clientUserDTO.userMobile
    }
  },
  methods: {
    changeResetType () {
      this.isPassword = false
      this.$refs.submitForm.resetValidation()
    },
    getVerifyCode () {
      if (this.disableSendBtn) {
        return
      }
      centerApi.sendClientVerifyCode().then(res => {
        if (res.data.resultCode === '0') {
          this.countDownIndex = 60
          this.disableSendBtn = true
          this.countDown()
        }
      })
    },
    countDown () {
      this.countDownIndex = 60
      let _vm = this
      let timer = setInterval(() => {
        _vm.countDownIndex--
        if (_vm.countDownIndex === 0) {
          _vm.disableSendBtn = false
          clearInterval(timer)
        }
      }, 1000)
    },
    onSubmit () {
      let params = {}

      params = {
        newPassword: cryptoUtils.AESEncrypt(this.params.newPassword),
        activationCode: this.params.verifyCode
      }
      centerApi.clientActivationSubmit(params).then(res => {
        if (res.data.resultCode === '0') {
          this.hintOverlay = true
        }
      })
    },
    handleActivation () {
      this.$refs.submitForm.submit()
    },
    handleLogout () {
      userUtils.removeUserLocal()
      this.$router.push({ name: 'home-main' })
    },
    goBack () {
      this.$router.go(-1)
    }
  }
}
</script>

<style>

</style>
